const PENDING_CHALLENGE_SCAN_KEY = 'colobongo_pending_challenge_scan_v1';

function isBrowser() {
  return typeof window !== 'undefined';
}

function normalizeChallengeContext(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const id = typeof raw.id === 'string' ? raw.id.trim() : '';
  if (!id) return null;

  const completedAt = typeof raw.completedAt === 'string' ? raw.completedAt : new Date().toISOString();
  const normalizedDate = new Date(completedAt);

  return {
    id,
    category: typeof raw.category === 'string' ? raw.category : '',
    color: typeof raw.color === 'string' ? raw.color : '',
    name: raw.name && typeof raw.name === 'object' ? raw.name : null,
    completedAt: Number.isNaN(normalizedDate.getTime()) ? new Date().toISOString() : normalizedDate.toISOString(),
  };
}

export function setPendingChallengeScanContext(context) {
  if (!isBrowser()) return;
  const normalized = normalizeChallengeContext(context);
  if (!normalized) return;
  try {
    window.sessionStorage.setItem(PENDING_CHALLENGE_SCAN_KEY, JSON.stringify(normalized));
  } catch (_error) {
    // best effort
  }
}

export function getPendingChallengeScanContext() {
  if (!isBrowser()) return null;
  try {
    const raw = window.sessionStorage.getItem(PENDING_CHALLENGE_SCAN_KEY);
    if (!raw) return null;
    return normalizeChallengeContext(JSON.parse(raw));
  } catch (_error) {
    return null;
  }
}

export function clearPendingChallengeScanContext() {
  if (!isBrowser()) return;
  try {
    window.sessionStorage.removeItem(PENDING_CHALLENGE_SCAN_KEY);
  } catch (_error) {
    // best effort
  }
}

export default {
  setPendingChallengeScanContext,
  getPendingChallengeScanContext,
  clearPendingChallengeScanContext,
};
